import { clsx } from 'clsx';
import { Text } from '@teachstonellc/component-library';
import { RadioGroup, RadioGroupItem } from '@radix-ui/react-radio-group';

const classes = clsx(
  'w-9 h-9 flex items-center justify-center border rounded-full cursor-pointer',

  // Checked state styles
  'data-[state=checked]:border-ds-blue-10 data-[state=checked]:bg-ds-blue-9 data-[state=checked]:text-ds-white',

  // Unchecked state styles
  'data-[state=unchecked]:border-ds-border data-[state=unchecked]:bg-ds-black-alpha-2 data-[state=unchecked]:hover:bg-ds-black-alpha-3'
);

interface DimensionScoreInputProps {
  value: string | null;
  onChange: (score: string) => void;
}

export function DimensionScoreInput({
  value,
  onChange
}: DimensionScoreInputProps) {
  const scores = ['1', '2', '3', '4', '5', '6', '7'];

  return (
    <RadioGroup
      value={value}
      onValueChange={onChange}
      className="flex items-center gap-2"
    >
      {scores.map(score => (
        <RadioGroupItem key={score} value={score} className={classes}>
          <Text variant="label0" className="cursor-pointer">
            {score}
          </Text>
        </RadioGroupItem>
      ))}
    </RadioGroup>
  );
}
